if (!customElements.get('sorasato-lp-recipes')) {
  customElements.define('sorasato-lp-recipes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.slp-recipe-track');
      this.previous = this.querySelector('[data-recipe-prev]');
      this.next = this.querySelector('[data-recipe-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const move = (direction) => {
        const first = this.track.firstElementChild;
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: step * direction, behavior: reduced ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      this.querySelector('.slp-recipe-controls').hidden = maximum <= 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
